import React from "react";

function About() {
  return (
    <div
      name="about"
      className="w-full min-h-screen bg-gradient-to-b from-gray-800 via-black to-gray-800 text-white pt-20"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8 ">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            About
          </p>
        </div>

        <prev className="text-xl mt-6 md:mt-20">
          I’m a second-year Computer Science student with a strong foundation in
          Data Structures, Algorithms, and core computer science principles,
          combined with hands-on experience in building scalable full-stack
          applications.
          <br />
          <br />
          I have solved 250+ algorithmic problems and focus on writing clean,
          efficient, and well-structured code. My approach emphasizes
          understanding trade-offs, edge cases, and performance rather than just
          achieving correct outputs.
          <br />
          <br />
          On the development side, I’ve built end-to-end MERN stack projects
          involving REST API design, authentication, role-based access, and
          real-world business logic. Notable projects include SkillSwap, a
          peer-to-peer skill exchange platform, and StockSense, a smart
          inventory system with real-time tracking, alerts, and intelligent
          recommendations.
          <br />
          <br />I enjoy breaking down complex problems, learning system-level
          thinking, and continuously strengthening my fundamentals in areas like
          backend scalability, Graphs, and Dynamic Programming. I’m actively
          seeking software engineering internship opportunities where strong
          problem-solving, ownership, and engineering rigor are valued.
        </prev>

        <br />
      </div>
    </div>
  );
}

export default About;
